// eslint-disable-next-line import/no-named-as-default
import gql from 'graphql-tag'
import { articleFields } from '../records/articleFragment.graphql'
import { lessonFields } from '../records/lessonFragment.graphql'
import { workshopFields } from '../records/workshopFragment.graphql'

export const sectionReadMoreFields = gql`
  fragment sectionReadMoreFields on SectionReadMoreRecord {
    modelApiKey: _modelApiKey
    links {
      ...articleFields
      ...lessonFields
      ...workshopFields
    }
  }
  ${articleFields}
  ${lessonFields}
  ${workshopFields}
`
